import { render, staticRenderFns } from "./PlpProduct26.vue?vue&type=template&id=51e79ca9&scoped=true"
import script from "./PlpProduct26.vue?vue&type=script&lang=js"
export * from "./PlpProduct26.vue?vue&type=script&lang=js"
import style0 from "./PlpProduct26.vue?vue&type=style&index=0&id=51e79ca9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e79ca9",
  null
  
)

/* custom blocks */
import block0 from "./translations?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fdata%2Fwww%2Fsrc%2Fcomponents%2F02-molecules%2Fplp-product-26%2FPlpProduct26.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports